var _mask, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#EDF1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1988 52.2234C50.9305 50.2985 49.6271 48.7201 47.7871 48.0656C43.6087 46.5257 38.7404 45.1012 34.9836 44.2158C34.8303 43.7153 34.7153 43.1763 34.6386 42.6758H39.5837C40.312 39.904 40.887 37.0936 41.3087 34.3218C41.0787 37.0166 40.5804 39.7115 39.9287 42.3679C39.8904 42.4449 40.0437 42.4834 40.0437 42.4064C41.347 38.5181 41.8454 34.2448 41.8071 30.1255C41.9604 28.3545 42.0754 26.6221 42.0371 25.0437C42.1137 25.7752 42.1521 26.5066 42.2287 27.2766C42.5354 32.3199 41.9221 37.2091 40.7337 42.0984C40.6954 42.1754 40.8487 42.2139 40.887 42.1369C42.4587 37.0166 42.9954 31.4344 42.6121 26.0832C42.4587 24.0813 42.3054 21.5019 41.6154 19.1535C41.6154 19.1535 41.6537 19.1535 41.6537 19.115C41.5387 17.2671 40.5804 15.1882 39.162 13.9947C38.357 13.3403 37.322 12.9553 36.3253 12.9938L35.4436 11.4924C31.8019 9.56746 27.5852 9.45197 23.9819 11.4539C22.6785 11.9928 21.4902 12.7628 20.6851 13.7253C18.8068 15.9582 17.8101 18.9225 17.3884 21.7714C16.8518 25.1977 17.1201 28.701 17.5034 32.1274C17.8868 35.5922 18.1168 39.211 19.0368 42.5604C19.0751 42.6373 19.1518 42.5989 19.1518 42.5219C18.4618 37.5941 17.5418 32.5893 17.4651 27.5846C17.6184 31.8194 18.3085 36.7856 19.4201 42.5989H24.5952C24.5185 43.1763 24.4035 43.7153 24.2502 44.3313C20.5318 45.2167 15.7784 46.6027 11.6384 48.0271C9.76002 48.6816 8.41835 50.2985 8.11168 52.2619C7.575 55.8037 7 60 7 60H52.3488C52.3488 59.9615 51.6972 55.4957 51.1988 52.2234ZM41.577 18.9225C41.462 18.6145 41.3854 18.268 41.232 17.9601C40.3887 15.2652 38.932 13.6483 36.7087 13.6483L36.517 13.3018C39.047 13.1478 41.232 16.5356 41.577 18.9225Z",
    fill: "url(#paint0_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 29.6744,
    y1: 10,
    x2: 29.6744,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1582FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4670FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar1);
export default __webpack_public_path__ + "static/media/avatar_1.96e2d232cbdcdd3a14317d29f2c41dc7.svg";
export { ForwardRef as ReactComponent };